import { GEOLOCATION_MODULE_TYPES } from 'client/javascript/pages/shared/constants';
import { HIDDEN_CLASS } from 'client/javascript/pages/product_details/constants';

export const renderMultipleModulesBasedOnUserGeolocation = (modules) => {
  modules[GEOLOCATION_MODULE_TYPES.OPTIONAL_MODULE_TYPE].forEach(({ shouldShowThisNode, nodeReference }) => {
    if (shouldShowThisNode) {
      nodeReference.classList.remove(HIDDEN_CLASS);
    } else {
      nodeReference.remove();
    }
  });

  modules[GEOLOCATION_MODULE_TYPES.DEFAULT_MODULE_TYPE].forEach(
    ({ nodeReference, shouldShowThisNode: conditionsToShow }) => {
      if (!conditionsToShow) {
        nodeReference.classList.remove(HIDDEN_CLASS);
      }
    }
  );
};
